/** @jsx h */
/* eslint-disable react/jsx-no-bind */
import { endpoints, labels } from '../config';

const EndpointsContainer = ({
  currentEndpoint,
  initialEndpoint,
  updateEndpoint,
}) => {
  function handleEndpointClick(e) {
    updateEndpoint(e.currentTarget.dataset.endpoint);
  }

  function checkCurrentEndpoint(url) {
    if (currentEndpoint) {
      return currentEndpoint === url;
    } else {
      return url === initialEndpoint;
    }
  }

  return (
    <fieldset className="search__endpoints search__container--medium">
      <legend className="sr-only">{labels.endpoints.legend}</legend>
      <ul className="search__endpoints-list">
        {endpoints.length
          ? endpoints.map((item, index) => (
              <li key={index}>
                <button
                  className={`text-l search__endpoint ${
                    checkCurrentEndpoint(item.url)
                      ? ' search__endpoint--current'
                      : ''
                  }`}
                  type="button"
                  data-endpoint={item.url}
                  onClick={handleEndpointClick}
                >
                  <span>{item.label}</span>
                </button>
              </li>
            ))
          : ''}
      </ul>
    </fieldset>
  );
};

export default EndpointsContainer;
